<table mat-table [dataSource]="dataSource" matSort class="bg-white">
  <!-- User Name -->
  <ng-container matColumnDef="userName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header style="cursor: pointer">User</th>
    <td mat-cell *matCellDef="let element" style="text-align: left">{{ element.userName }}</td>
  </ng-container>

  <!-- Fit & Proper Decl -->
  <ng-container matColumnDef="fitAndProperDeclarationStatus">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Fit &amp; Proper Decl</th>
    <td mat-cell *matCellDef="let element" class="text-center">
      <a [routerLink]="['/uk', 'fit-and-proper-declaration', element.userEmail]">
        @if (element.fitAndProperDeclarationStatus === DeclarationStatus.NotCreated) {
          <span class="material-icons text-danger">close</span>
        }
        @if (element.fitAndProperDeclarationStatus === DeclarationStatus.Created) {
          <span class="material-icons text-warning">info_outlined</span>
        }
      </a>
      @if (element.fitAndProperDeclarationStatus === DeclarationStatus.Submitted) {
        <button
          class="btn btn-sm"
          (click)="
            showComplianceCheckDialog(
              element.fitAndProperDeclarationId,
              DeclarationType.EmployeeFitAndProperDeclaration
            )
          "
        >
          <i class="bi bi-hourglass text-warning" title="Pending compliance check"></i>
        </button>
      }
      @if (element.fitAndProperDeclarationStatus === DeclarationStatus.ComplianceChecked) {
        <div class="d-flex justify-content-center align-items-center">
          <a [routerLink]="['/uk', 'fit-and-proper-declaration', element.userEmail]">
            <span class="material-icons text-success">check</span>
          </a>
          <button
            class="btn btn-sm"
            (click)="
              requestToGeneratePdfDeclaration(
                element.fitAndProperDeclarationId,
                DeclarationType.EmployeeFitAndProperDeclaration
              )
            "
          >
            <i class="bi bi-file-earmark-pdf" title="Regenerate PDF declaration"></i>
          </button>
        </div>
      }</td
  ></ng-container>

  <!-- SMCR -->
  <ng-container matColumnDef="smcrStatus">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>SM&amp;CR</th>
    <td mat-cell *matCellDef="let element" class="text-center">
      <a [routerLink]="['/uk', 'smcr', element.userEmail]">
        @if (element.smcrStatus === DeclarationStatus.NotCreated) {
          <span class="material-icons text-danger">close</span>
        }
        @if (element.smcrStatus === DeclarationStatus.Created) {
          <span class="material-icons text-warning">info_outlined</span>
        }
      </a>
      @if (element.smcrStatus === DeclarationStatus.Submitted) {
        <button class="btn btn-sm" (click)="showComplianceCheckDialog(element.smcrId, DeclarationType.Smcr)">
          <i class="bi bi-hourglass text-warning" title="Pending compliance check"></i>
        </button>
      }
      @if (element.smcrStatus === DeclarationStatus.ComplianceChecked) {
        <div class="d-flex justify-content-center align-items-center">
          <a [routerLink]="['/uk', 'smcr', element.userEmail]">
            <span class="material-icons text-success">check</span>
          </a>
          <button class="btn btn-sm" (click)="requestToGeneratePdfDeclaration(element.smcrId, DeclarationType.Smcr)">
            <i class="bi bi-file-earmark-pdf" title="Regenerate PDF declaration"></i>
          </button>
        </div>
      }</td
  ></ng-container>

  <!-- Statement of Responsibilities -->
  <ng-container matColumnDef="statementOfResponsibilitiesStatus">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>SoR</th>
    <td mat-cell *matCellDef="let element" class="text-center">
      <a [routerLink]="['/uk', 'statement-of-responsibilities', element.userEmail]">
        @if (element.statementOfResponsibilitiesStatus === DeclarationStatus.NotCreated) {
          <span class="material-icons text-danger">close</span>
        }
        @if (element.statementOfResponsibilitiesStatus === DeclarationStatus.Created) {
          <span class="material-icons text-warning">info_outlined</span>
        }
      </a>
      @if (element.statementOfResponsibilitiesStatus === DeclarationStatus.Submitted) {
        <button
          class="btn btn-sm"
          (click)="
            showComplianceCheckDialog(
              element.statementOfResponsibilitiesId,
              DeclarationType.StatementOfResponsibilities
            )
          "
        >
          <i class="bi bi-hourglass text-warning" title="Pending compliance check"></i>
        </button>
      }
      @if (element.statementOfResponsibilitiesStatus === DeclarationStatus.ComplianceChecked) {
        <div class="d-flex justify-content-center align-items-center">
          <a [routerLink]="['/uk', 'statement-of-responsibilities', element.userEmail]">
            <span class="material-icons text-success">check</span>
          </a>
          <button
            class="btn btn-sm"
            (click)="
              requestToGeneratePdfDeclaration(
                element.statementOfResponsibilitiesId,
                DeclarationType.StatementOfResponsibilities
              )
            "
          >
            <i class="bi bi-file-earmark-pdf" title="Regenerate PDF declaration"></i>
          </button>
        </div>
      }</td
  ></ng-container>

  <!-- Compliance Manual -->
  <ng-container matColumnDef="ackedComplianceManual">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Compl Manual</th>
    <td mat-cell *matCellDef="let element" class="text-center">
      @if (element.ackedComplianceManual) {
        <span [title]="element.complianceManualReadingTimeMs | dhumanize">
          <span class="material-icons text-success">check</span>
        </span>
      } @else {
        <span class="material-icons text-danger">close</span>
      }
    </td></ng-container
  >

  <!-- Completion Date -->
  <ng-container matColumnDef="completionDate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Completion Date</th>
    <td mat-cell *matCellDef="let element">
      {{ element.completionDate | date }}
    </td></ng-container
  >

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let element; columns: displayedColumns" class="element-row"></tr>
</table>
@if (loading) {
  <div class="d-flex justify-content-center m-3">
    <ad-spinner />
  </div>
}
